export default {
  id: 'procedures/UNDERTAKEN/v1',
  formSchema: {
    title: 'encounter:widget.procedures.undertaken',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.procedures.undertaken',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
